interface IPriceStat {
  stat: string;
  subtext: string;
}
export const PriceStat: React.FC<IPriceStat> = ({ stat, subtext }) => {
  return (
    <div className="text-center">
      <p className="inline-block text-s-32 sm:text-s-20 font-bold text-font-500">
        {stat}
      </p>
      <br />
      <p className="text-font-200 sm:text-s-10">{subtext}</p>
    </div>
  );
};
